import { createId } from "../../app/runtimeContext";
import type { EventBus } from "../events/eventBus";

export type TaskStatus =
  | "Planning"
  | "Approved"
  | "Executing"
  | "Testing"
  | "Review"
  | "Completed"
  | "Failed"
  | "Cancelled"
  | "Blocked";

export type RuntimeTask = {
  id: string;
  organizationId: string;
  productId: string;
  departmentId?: string;
  agentId?: string;
  title: string;
  description: string;
  status: TaskStatus;
  createdAt: string;
  updatedAt: string;
  dependencies: string[];
  owner: string;
  logs: string[];
  events: string[];
  memoryLinks: string[];
};

export type TaskRecord = RuntimeTask;

export class TaskEngine {
  private readonly tasks = new Map<string, RuntimeTask>();

  constructor(private readonly eventBus: EventBus) {}

  async createTask(
    input: Omit<
      RuntimeTask,
      "id" | "createdAt" | "updatedAt" | "logs" | "events"
    >,
  ): Promise<RuntimeTask> {
    const now = new Date().toISOString();
    const task: RuntimeTask = {
      ...input,
      id: createId("task"),
      createdAt: now,
      updatedAt: now,
      logs: [],
      events: [],
      status: input.status,
    };
    this.tasks.set(task.id, task);
    await this.eventBus.publish({
      id: createId("event"),
      name: "TaskCreated",
      payload: task,
      timestamp: now,
      correlationId: createId("taskcorr"),
    });
    return task;
  }

  list(): RuntimeTask[] {
    return [...this.tasks.values()];
  }
}
